import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { useNavigate, useParams } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import UploadReport from "./uploadReport";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";
import FamilyAppointmentCancel from "./familyAppointmentCancelPopup";
import AppointmentReschedule from "./appointmentReschedule";
import { Pagination } from "react-bootstrap";
import PemeAppointmentReschedule from "./pemeAppointmentReschedule";
import PemeAppointmentCancel from "./pemeAppointmentCancellation";
import UploadPemeReport from "./uploadPemeAppointmentReport";
import { FaEdit, FaEye } from "react-icons/fa";

function ViewPemeAppointmentsForLab({ labId }) {
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [loader, setLoader] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isReschedulePopupOpen, setIsReschedulePopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("all");
   const [companies, setCompanies] = useState([]);
   const userRole = JSON.parse(localStorage.getItem("data")).role;

  const navigate = useNavigate();

   useEffect(() => {
     if (searchTerm || selectedCompany !== "all" ) {
       setCurrentPage(0); // Reset page before fetching new search data
     }
   }, [searchTerm, selectedCompany]);
   
   useEffect(() => {
     if (searchTerm|| selectedCompany !== "all") {
       searchData(currentPage); // Fetch new search data with updated page number
     } else {
       getData(currentPage);
     }
   }, [searchTerm,selectedCompany,currentPage]);
   

  const searchData = async (pageNumber = 0) => {
      const token = JSON.parse(localStorage.getItem("data")).token;
      setLoader(true);
    
      try {
        const searchUrl=`/api/peme-appointment/seachPemeAppointmentsForLab`;
           const requestData = {
                            labId:labId,
                            companyId: selectedCompany === "all" ? null : selectedCompany,                             searchTerm,
                           };
                const response = await axios.post(searchUrl, requestData,{
                  params: { page: pageNumber },
                  headers: { Authorization: `Bearer ${token}` }, 
                });
    
        setAppointmentDetails(response.data.content);
        setCurrentPage(response.data.number);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        handleError(error);
      } finally {
        setLoader(false);
      }
    };
    

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const trans = await axios.get(`/api/peme-appointment/getAllPemeAppointments/labId=${labId}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(trans.data.content);
      // setFilteredData(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);

      const response = await axios.get("/api/companydetails/getCompanies", {
              headers: { Authorization: `Bearer ${token}` },
            });
            setCompanies(response.data);
      

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleCancelClick = async (appointment) => {
    setSelectedAppointment(appointment)
    setIsCancelPopupOpen(true);
  };
  
  const handleCloseCancelPopup = () => {
    setIsCancelPopupOpen(false);
    getData();
  };


  const handleUploadReport = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsUploadModalOpen(true);
  };

  const handleCloseUploadModal = () => {
    setIsUploadModalOpen(false);
    getData();
  };
 
  const handleViewPdf = async (appointmentId) => {
  const token = JSON.parse(localStorage.getItem("data")).token;
  await axios({
    url: `/api/peme-appointment/download/id=${appointmentId}`,
    method: "GET",
    responseType: "blob",
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    console.log("filedata;", response);
    const contentType = response.headers["content-type"];
    let extension = "";

    // Determine the file extension based on content type
    if (contentType.includes("application/pdf")) {
      extension = "pdf";
    } else if (contentType.includes("image/jpeg")) {
      extension = "jpg";
    } else if (contentType.includes("image/png")) {
      extension = "png";
    } else {
      console.error("Unsupported file type:", contentType);
      return;
    }

    // Create a blob URL and download link for the file
    const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `file.${extension}`);
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  });
}

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }


  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const openTestsModal = (pkg) => {
    setSelectedPackage(pkg);
      setIsTestsModalOpen(true);
  };

  const closeTestsModal = () => {
    setSelectedPackage(null);
    setIsTestsModalOpen(false);
  };

  const handleAcceptAppointment = async (appointmentId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoader(true);
    try {
      await axios.post(
        "/api/peme-appointment/reschedule",
        {
          id: `${appointmentId}`,
          appointmentstatus: "APPOINTMENT CONFIRMED",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Employee Appointment Confirmed successfully.");
      getData();
      setLoader(false);
    } catch (error) {
    setLoader(false);
      handleError(error);
 
    }
  };

  const handleRescheduleAppointment = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsReschedulePopupOpen(true);
  };

  const handleCloseReschedulePopup = () => {
    setIsReschedulePopupOpen(false);
    getData();
  };

  const handleBack = () => {
    navigate(-1);
   };

   const handleFetchReport= async (appointment) => {
    setLoader(true); 
    const token = JSON.parse(localStorage.getItem('data')).token;

    try {
      await axios.post('/api/peme-appointment/fetchReport', appointment, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Report fetched successfully');
      getData();
    } catch (error) {
     handleError(error);
    } finally {
      setLoader(false); 
    }
  };

   const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };


  return (
    <div>
        {loading && <div className="loading"></div>}
      <div className="col-12 mx-xl-auto">
      <div className="mb-2">
                      <button className="btn btn-primary" onClick={handleBack}>
                        Back
                      </button>
                    </div>
        <div className="card card-raised">
          <div className="card-body">
            <div className="card-title">
           PEME Appointment Details:
              </div>
              <div className="row form-group d-flex align-items-center gap-3 mt-2">
  <div className="form-group position-relative" style={{ width: '300px' }}>
    <input
      type="search"
      className="form-control"
      placeholder="Search by Name or Phone number"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      style={{ paddingLeft: "2rem", width: "100%" }}
    />
    <span className="position-absolute" style={{ left: "25px", top: "50%", transform: "translateY(-50%)" }}>
      <FontAwesomeIcon icon={faSearch} />
    </span>
  </div>
{(userRole!=='ROLE_LAB' && userRole!=='ROLE_LAB_CORPORATE') && (
  <div className="d-flex align-items-center" style={{ width: '300px' }}>
    <label htmlFor="companyFilter" className="form-label mb-0 me-2">
      Filter by Company:
    </label>
    <select
      id="companyFilter"
      className="form-select"
      value={selectedCompany || "all"}
      onChange={(e) => setSelectedCompany(e.target.value)}
    >
      <option value="all">All Companies</option>
      {companies.map((company) => (
        <option key={company.id} value={company.id}>
          {company.companyname}
        </option>
      ))}
    </select>
  </div>
)}
</div>


            <br />
            <div className="table-responsive">
            <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                    <th>Sl.No.</th>
                  <th>Name</th>
                  <th>Phone Number</th>
                  <th>Date</th>
                  <th>Company</th>
                  <th>Package</th>
                  <th>Status</th>
                  <th>Report</th>
                  <th>Order Status</th>
                </tr>
              </thead>
              <tbody>
                {appointmentDetails.length === 0 ? (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No Data Available
                    </td>
                  </tr>
                ) : (
                  appointmentDetails.map((appointment, index) => (
                    <tr key={appointment.id}>
                      <td>{index + 1}</td>
                       <td
  style={{
    cursor: (
             appointment.appStatus?.appointmentStatus === 'APPOINTMENT CANCELLED' || 
             appointment.appStatus?.appointmentStatus === 'APPOINTMENT COMPLETED') 
            ? "default" 
            : "pointer",
  }}
  title="Upload Report"
  onClick={() => {
    if (
      appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED' &&
      appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED'
    ) {
      handleUploadReport(appointment.id);
    }
  }}
  onMouseOver={(e) => {
    if (
      appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED' &&
      appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED'
    ) {
      e.target.style.color = "blue";
      e.target.style.textDecoration = "underline";
    }
  }}
  onMouseOut={(e) => {
    e.target.style.color = "";
    e.target.style.textDecoration = "";
  }}
>


                          {appointment.pemeDetails?.fullName} 
         
                     
                      </td>
                      <td>{appointment.pemeDetails?.phoneNumber}</td>
                      <td>{appointment.appointmentDate}</td>
                      {/* <td>{appointment.time}</td> */}
                      <td>{appointment.company?.companyname}</td>
                    
                      <td style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>{appointment.pack?.packagename}</span>
              <FiInfo
                 onClick={() => openTestsModal(appointment.packageid)}
                style={{
                  cursor: 'pointer'
                }}
              />
                      </td>
                      <td>
  <div>{appointment.appStatus?.appointmentStatus}</div>
  {(appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED') && (appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED') && (
  // {appointment.appointmentstatus !== 'APPOINTMENT CANCELLED' && appointment.appointmentstatus !== 'COMPLETED' && (
  <>
    <div>
      
 <div className="mt-2">
      <button
        className="btn btn-danger btn-sm rounded-pill"
        onClick={() => handleCancelClick(appointment)}
      >
        Cancel
      </button>
      </div>
    <div className="mt-2">
      <button
        className="btn btn-warning btn-sm rounded-pill"
        onClick={() => handleRescheduleAppointment(appointment.id)}
      >
        Reschedule
      </button>
    </div>
    </div>
  </>
)}
</td>
<td>
{appointment.orderStatus ? (
    appointment.orderStatus?.appointmentReport ? (
      appointment.reportstatus === 'APPROVED' ? (
        <div>
          {/* Display the appointment report as a link if approved */}
          <a
            href={appointment.orderStatus.appointmentReport}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Report
          </a>
        </div>
      ) : (
      "APPROVAL PENDING"
      )
    ) : (
      <button onClick={() => handleFetchReport(appointment)}>
        Fetch Report
      </button>
    )
  ) : (
    appointment.reportstatus ? (
      appointment.reportstatus === 'APPROVED' ? (
       <>
                            <FaEye
                              className="text-black me-3 cursor-pointer"
                              size={20}
                              onClick={() => handleViewPdf(appointment.id)}
                              title="View Report"
                              style={{cursor:"pointer"}}
                            />
              
              { (userRole === "ROLE_ADMIN" || userRole === "ROLE_SUPER") && (
                            <FaEdit
                              className="text-black cursor-pointer"
                              size={20}
                              onClick={() => handleUploadReport(appointment.id)}
                              title="Modify Report"
                              style={{cursor:"pointer"}}
                            />
              )}
                          </>
      ) : (
        "APPROVAL PENDING"
      )
    ) : (
      "No Report Added"
    )
  )}
</td>

<td>
  <div>{appointment.orderStatus?.status}</div>

  <div>
    {appointment.orderStatus ? (
      <>
      <br/>
        {appointment.orderStatus?.orderId === "" || appointment.orderStatus?.orderId == null ? (  // Check for both empty string and null/undefined
          <>
            {/* <button
              onClick={() => handleRetry(appointment)}
              style={{ cursor: 'pointer', color: 'red' }}
            >
              Retry
              <FaRedoAlt />
            </button> */}
          </>
        ) : (
          <div>{appointment.orderStatus?.orderId}</div>
        )}
      </>
    ) : (
      <div>NA</div>
    )}
  </div>
</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            </div>
            <div className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
              </Pagination>
            </div>
          </div>
        </div>

        {isTestsModalOpen && (
            <TestForPackage
                    isOpen={isTestsModalOpen}
                    onRequestClose={closeTestsModal}
                    packageId={selectedPackage}
                  />
            )}

  {isReschedulePopupOpen && (
          <PemeAppointmentReschedule
            isOpen={isReschedulePopupOpen}
            onRequestClose={handleCloseReschedulePopup}
            appointmentId={selectedAppointmentId}
          />
        )}

{isCancelPopupOpen &&(
   <PemeAppointmentCancel
   isOpen={isCancelPopupOpen}
   onRequestClose={handleCloseCancelPopup}
   appointment={selectedAppointment}
 />
)}

   {isUploadModalOpen && (
          <UploadPemeReport
            isOpen={isUploadModalOpen}
            onRequestClose={handleCloseUploadModal}
            pemeAppointmentId={selectedAppointmentId}
          />
        )}


        {loader && <div className="loading"></div>}
      </div>
    </div>
  );
}

export default ViewPemeAppointmentsForLab;
